import React from 'react';
import { getAppURLs } from './appLinks';
import { MAPPER_URL, TERMBROWSER_URL } from './constants';

const PRODUCTION = { termBrowser: TERMBROWSER_URL, mapper: MAPPER_URL };

// The OCL apps' links (common/appLinks.js) for a prerendered page's buttons.
// toV3URL and toMapperURL read window.location. React keeps a prerendered attribute that
// differs from the client's first render, so a link resolved during render
// never gains it on a full page load. They're resolved after mount instead
// (docs/SEO-AUDIT.md bug #8); until then they're the production apps, so the
// buttons work before the page hydrates.
const useAppURLs = () => {
  const [urls, setURLs] = React.useState(PRODUCTION);
  React.useEffect(() => { setURLs(getAppURLs('/')); }, []);
  return urls;
};

export default useAppURLs;
